import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Shell from "./Shell.js";
import LoginPage from "./LoginPage.js";
import { useSession } from "./session/SessionContext.js";
import { operacionesRoutes } from "../modules/operaciones/routes.js";
import { finanzasRoutes } from "../modules/finanzas/routes.js";
import { soporteRoutes } from "../modules/soporte/index.js";
import { plataformaRoutes } from "../modules/plataforma/routes.js";
import { analyticsRoutes } from "../modules/analytics/routes.js";
import { devToolsRoutes } from "../modules/dev-tools/routes.js";

function RequireSession() {
  const { user, loading } = useSession();
  if (loading) {
    return (
      <div className="flex min-h-dvh flex-col items-center justify-center gap-3 bg-zinc-950">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-zinc-700 border-t-emerald-500" />
        <p className="text-xs uppercase tracking-widest text-zinc-500">RediPOS ERP</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Shell />;
}

/**
 * Router raíz: solo ensambla lo que cada módulo aporta, no conoce el
 * contenido de ningún módulo. Agregar un módulo nuevo = agregar una línea
 * acá + su carpeta en modules/ — nada más se toca.
 */
export default function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireSession />}>
        {analyticsRoutes}
        {operacionesRoutes}
        {finanzasRoutes}
        {soporteRoutes}
        {plataformaRoutes}
        {devToolsRoutes}
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
